import { CascaderField, Col } from '@/components';
import { usePoliciesOptions } from '@/features/master-table/policy/_hooks/policy';
import { PS_MAX_CASCADER_SELECTION } from '@/features/project/_utils/constants';
import { useGetReferenceFiscalYearBySearchType } from '@/features/search/_hooks/projects-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import {
  COL_MIN_WIDTH,
  handleCascaderOnChange,
} from '@/features/search/_utils/projects-search';
import { useMessage } from '@/providers';
import { isPS } from '@/utils';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const NestedPolicyIdsColField: FC = memo(() => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const {
    control: sharedSearchControl,
    formState: { errors },
    setValue: setSharedSearchValue,
  } = useFormContext<SharedSearchFormType>();

  const referenceFiscalYear = useGetReferenceFiscalYearBySearchType();

  const policiesOptions = usePoliciesOptions({
    params: { referenceFiscalYear: referenceFiscalYear?.toString() },
  });

  const sheetType = useWatch({
    control: sharedSearchControl,
    name: 'sheetType',
  });

  if (sheetType !== 'RS') {
    return null;
  }

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <CascaderField
        name="nestedPolicyIds"
        label={t('policy')}
        control={sharedSearchControl}
        options={policiesOptions.data}
        loading={policiesOptions.isPending}
        multiple
        errors={errors}
        hint={
          isPS()
            ? t('hint-cascader-selection', {
                limit: PS_MAX_CASCADER_SELECTION,
              })
            : undefined
        }
        onChange={(value) => {
          handleCascaderOnChange(
            'nestedPolicyIds',
            value?.map((v) => v.map((v) => v.toString())) ?? [],
            setSharedSearchValue,
            openMessage,
          );
        }}
      />
    </Col>
  );
});
